import React, { Component } from 'react';
import classNames from 'classnames/bind';
import parseHtmlToReact from 'html-react-parser';
import PropTypes from 'prop-types';

import { Button } from 'bricks/_landings';
import { formatPrice } from 'utils/formatting';

import { Dropdown, Heading, Preloader } from '..';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export default class CalculatorLayout extends Component {
  componentDidMount() {
    this.props.getTypes();
  }

  render() {
    const {
      buttonHref,
      error,
      footNote = '',
      hasError,
      headline,
      headlineTagName,
      isMobile,
      isTradeInNewPage,
      isWait,
      maxPrice,
      optionsList,
      selectOption,
      title,
    } = this.props;

    return (
      <div className={cx('component', isMobile ? 'mobile' : '', isTradeInNewPage && 'new-page')}>
        <div className={cx('inner')}>
          {headline ?
            <Heading className={cx('headline')} level={2} tagName={headlineTagName}>
              {headline}
            </Heading>
          : null}
          <div className={cx('block')}>
            {isWait ?
              <div className={cx('loader')}>
                <Preloader />
              </div>
            : null}
            <div className={cx('column')}>
              <div className={cx('form')}>
                {optionsList.map((item, index) => (
                  <div className={cx('row')} key={+index}>
                    <Dropdown
                      className={cx('dropdown')}
                      disabled={item.list.length === 0}
                      onChange={(value) => {
                        selectOption(item.slug, value);
                      }}
                      options={item.list}
                      placeholder={item.title}
                      value={item.activeOption}
                      wide
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className={cx('column', 'columnRes')}>
              <div className={cx('total')}>
                <div className={cx('title')}>{title}</div>
                <div className={cx('price')}>{formatPrice(maxPrice)} ₽</div>
                {hasError ?
                  <div className={cx('error')}>{error}</div>
                : null}
              </div>
              {buttonHref && (
                <Button href={buttonHref} isMedium isPrimary>
                  К покупке
                </Button>
              )}
            </div>
          </div>
          {footNote && <div className={cx('footNote')}>{parseHtmlToReact(footNote)}</div>}
        </div>
      </div>
    );
  }
}

CalculatorLayout.propTypes = {
  buttonHref: PropTypes.string,
  error: PropTypes.string,
  footNote: PropTypes.string,
  getTypes: PropTypes.func,
  hasError: PropTypes.bool,
  headline: PropTypes.string,
  headlineTagName: PropTypes.string,
  isMobile: PropTypes.bool,
  isWait: PropTypes.bool,
  maxPrice: PropTypes.string,
  optionsList: PropTypes.array,
  selectOption: PropTypes.func,
  title: PropTypes.string,
};
